module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ramsen-75b2584b20b73851a126c4f5b102b80e.png";